// extracted by mini-css-extract-plugin
export default {"globalWrapper":"BaseLayout_globalWrapper__yGVYL","routerWrapper":"BaseLayout_routerWrapper__eJRiL","navigationWrapper":"BaseLayout_navigationWrapper__+3Z8O"};